import React from 'react';
import { fitnessProfileSurfaceCardClassName } from './fitnessProfileReadingStyles';

export default function FitnessProfileSectionCard({ title, subtitle, headerAction, children }) {
	return (
		<div className={`${fitnessProfileSurfaceCardClassName} p-5`}>
			<div className="mb-3 flex items-start justify-between gap-3">
				<div className="min-w-0">
					<h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
					{subtitle && <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>}
				</div>
				{headerAction}
			</div>
			{children}
		</div>
	);
}
